import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';

import './SegmentedToggle.styles.scss';

type SegmentedToggleValue = string | number | boolean;

type SegmentedToggleOption = {
  label: React.ReactNode;
  value: SegmentedToggleValue;
};

type SegmentedToggleProps = {
  className?: string;
  options: SegmentedToggleOption[];
  selectedValue: SegmentedToggleValue;
  onChange: (value: SegmentedToggleValue) => void;
};

const SegmentedToggle: React.FC<SegmentedToggleProps> = (props) => {
  const { className, options, selectedValue, onChange } = props;

  const classes = classNames('segmented-toggle', className);

  return (
    <div className={classes}>
      {options.map(({ label, value }) => (
        <Button
          key={String(value)}
          className={classNames({
            selected: selectedValue === value,
          })}
          onClick={() => onChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default SegmentedToggle;
